export const SETTLEMENT_DELETE_RESET = 'SETTLEMENT_DELETE_RESET'
export const SETTLEMENT_DELETE_SET_ERROR = 'SETTLEMENT_DELETE_SET_ERROR'
export const SETTLEMENT_DELETE_SET_DELETED = 'SETTLEMENT_DELETE_SET_DELETED'
export const SETTLEMENT_DELETE_TOGGLE_LOADING = 'SETTLEMENT_DELETE_TOGGLE_LOADING'
